import React, { useState } from 'react'
import { Grid, makeStyles, Typography, FormLabel } from '@material-ui/core'
import _ from 'lodash'
import Files from 'react-butterfiles'
import { styled } from '@material-ui/core'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'
import IconDragnDrop from '../../../../../../src/assests/images/insuranceCard.png'
import completeIcon from '../../../../../../src/assests/images/completeIcon.svg'
import CloseIcon from '../../../../../../src/assests/images/closeIcon.svg'
import { useNotification } from '../../../MaterialUi/Notification'

const useStyles = makeStyles(() => ({
    open_browser_file: {
        color: '#5473C9',
        fontFamily: 'Inter',
        fontStyle: 'Medium',
        fontWeight: 500,
        fontSize: '13px',
        cursor: 'pointer',
    },
    selectText: {
        color: '#000000',
        fontFamily: 'Inter',
        fontStyle: 'Medium',
        fontWeight: 500,
        fontSize: '13px',
    },
    supportText: {
        color: '#7F7E7E',
        fontFamily: 'Inter',
        fontStyle: 'Medium',
        fontWeight: 500,
        fontSize: '11px',
    },
    fileName: {
        fontFamily: 'Inter',
        fontStyle: 'Medium',
        fontWeight: 500,
        fontSize: '11px',
        color: '#000000',
    },
    placeholder: {
        display: 'flex',
        fontFamily: 'Inter',
        justifyContent: 'center',
        color: '#454545',
        marginBottom: '6px',
        fontWeight: 600,
        fontSize: '14px',
        textTransform: 'none',
    },
}))

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 5,
    width: '100%',
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: '#D9D9D9',
        borderRadius: 5,
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: '#5473C9',
    },
}))

function InsuranceCard(props) {
    const classes = useStyles()
    const notification = useNotification()
    const [isHover, setIsHover] = useState(false)
    const [files, setFiles] = useState([])
    const [isUploading, setIsUploading] = React.useState(false)

    const onUploadProgress = (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        props?.setUploadProgress(percentCompleted)
        if (percentCompleted) {
            setIsUploading(false)
        }
    }

    const simulateProgress = (duration = 2000) => {
        return new Promise((resolve) => {
            let progress = 0
            const step = 100 / (duration / 100) // update every 100ms

            const interval = setInterval(() => {
                progress += step
                if (progress >= 100) {
                    progress = 100
                    clearInterval(interval)
                    resolve()
                }
                props?.setUploadProgress(Math.round(progress))
            }, 100)
        })
    }
    const handleUploadAttachmentFile = async (files = []) => {
        try {
            if (files.length) {
                setFiles(files) // store in state (local variable)
                const file = files[0]
                props?.setPatientInsurance(file)
                setIsUploading(true)
                props?.setUploadProgress(0)
                await simulateProgress(2000)
                const fileContext = await new Promise((resolve, reject) => {
                    const reader = new FileReader()
                    reader.addEventListener('progress', (event) => {
                        if (event.lengthComputable) {
                            onUploadProgress({
                                loaded: event.loaded,
                                total: event.total,
                            })
                        }
                    })
                    reader.addEventListener('loadend', (event) => {
                        setTimeout(() => {
                            resolve(event.target.result)
                        }, 5000)
                    })
                    reader.addEventListener('error', reject)
                    reader.readAsArrayBuffer(file?.src?.file)
                })
            } else {
                props?.setPatientInsurance({})
            }
        } catch (err) {
            console.error('File upload error:', err)
        } finally {
            setIsUploading(false)
        }
    }
    const handleErrors = (errors) => {
        notification(
            errors[0]?.type == 'maxSizeExceeded'
                ? 'File size exceeds the maximum limit of 10 MB.'
                : 'Something went wrong!',
            'error',
        )
        setIsHover(false)
        setFiles([])
        setIsUploading(false)
    }
    return (
        <Grid container style={{ padding: '10px' }}>
            <Grid item xs={12}>
                <FormLabel className={classes?.placeholder}>
                    {props?.placeholder || 'Upload file'}
                </FormLabel>
                <Files
                    multiple={false}
                    Extension
                    multipleMaxSize="10mb"
                    maxSize="10mb"
                    accept={['image/jpg', 'image/jpeg', 'image/png', 'application/pdf']}
                    onSuccess={handleUploadAttachmentFile}
                    onError={handleErrors}>
                    {({ browseFiles, getDropZoneProps }) => {
                        return (
                            <>
                                <div
                                    {...getDropZoneProps({
                                        style: {
                                            // height: '228px',
                                            // width: '418px',
                                            borderRadius: 4,
                                            border: '2px #5473C9 dashed',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexDirection: 'column',
                                            gap: '10px',
                                            padding: '35px',
                                        },
                                    })}
                                    onDragEnter={(e) => {
                                        setIsHover(true)
                                    }}
                                    onDragLeave={(e) => {
                                        setIsHover(false)
                                    }}>
                                    {!isHover ? (
                                        <>
                                            <img
                                                src={IconDragnDrop}
                                                alt=""
                                                style={{
                                                    // width: '131px',
                                                    // height: '92px',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                            <Typography className={classes?.selectText}>
                                                Drop your image here, or{' '}
                                                <span
                                                    className={classes.open_browser_file}
                                                    onClick={() => {
                                                        if (!isUploading) {
                                                            browseFiles()
                                                        }
                                                    }}>
                                                    browse your files
                                                </span>{' '}
                                            </Typography>
                                            <Typography className={classes?.supportText}>
                                                Supports: PNG, JPG, JPEG, PDF
                                            </Typography>
                                            <Typography className={classes?.supportText}>
                                                Max File Size: 10 mb
                                            </Typography>
                                        </>
                                    ) : (
                                        <Typography className={classes?.selectText}>
                                            Drop here
                                        </Typography>
                                    )}
                                </div>
                                {(files.length != 0 || props?.insurance?.name) && (
                                    <div
                                        style={{
                                            borderRadius: 5,
                                            border: '1px #A7A7A7 solid',
                                            marginTop: '7px',
                                        }}>
                                        <>
                                            <div style={{ padding: '5px 5px 5px 14px' }}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                    }}>
                                                    <span className={classes.fileName}>
                                                        {files[0]?.name
                                                            ? files[0]?.name
                                                            : props?.insurance?.name}
                                                    </span>{' '}
                                                    {props?.uploadProgress === 100 ? (
                                                        <div>
                                                            <img
                                                                src={completeIcon}
                                                                alt=""
                                                                style={{
                                                                    width: '15px',
                                                                    height: '16px',
                                                                }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <img
                                                                src={CloseIcon}
                                                                alt=""
                                                                style={{
                                                                    width: '15px',
                                                                    height: '16px',
                                                                    cursor: 'pointer',
                                                                }}
                                                                onClick={() => {
                                                                    setFiles([]),
                                                                        setIsUploading(false),
                                                                        handleUploadAttachmentFile(
                                                                            [],
                                                                        )
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                                </div>

                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: '8px',
                                                    }}>
                                                    <BorderLinearProgress
                                                        variant="determinate"
                                                        value={props?.uploadProgress}
                                                    />
                                                    <span
                                                        className={classes.fileName}
                                                        style={{ fontSize: '7px' }}>
                                                        {props?.uploadProgress}%
                                                    </span>
                                                </div>
                                            </div>
                                        </>
                                    </div>
                                )}
                            </>
                        )
                    }}
                </Files>
            </Grid>
        </Grid>
    )
}
export default React.memo(InsuranceCard)
